import { defineQuery, defineQueryOptions } from '@pinia/colada'
import jwtDecode from 'jwt-decode'

export const AUTH_QUERY_KEYS = {
  token: ['auth', 'token'] as const,
}

const authTokenQuery = defineQueryOptions({
  key: AUTH_QUERY_KEYS.token,
  async query() {
    const client = useRequestFetch()
    const { token } = await client<{ token: string | null }>('/api/get-token')
    return token
  },
  staleTime: 1000 * 60 * 60 * 24 - 60_000,
})

export const useAuthToken = defineQuery(authTokenQuery)

/* The query cache persists across reloads, so a cached token can be long
 * expired; anything expiring within a minute is treated as unusable. */
export const isTokenFresh = (
  token: string | null | undefined,
): token is string => {
  if (!token) return false
  try {
    const { exp } = jwtDecode<{ exp?: number }>(token)
    return Boolean(exp) && exp! * 1000 > Date.now() + 60_000
  } catch {
    return false
  }
}

/** For diagnostics only: why a token is or isn't usable, never its contents. */
export const tokenState = (token: string | null | undefined) =>
  !token ? 'missing' : isTokenFresh(token) ? 'fresh' : 'expired'
